module.exports = __webpack_public_path__ + "img/awards_50.eb2be181.png";